import { Component } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

import { DriverCardService } from '@core/driver-card.service';

marker('tachomat.remove-device.driver-card.title-info');
marker('tachomat.remove-device.driver-card.title-page');

@Component({
	selector: 'tacho-remove-card',
	templateUrl: './remove-card.component.html'
})
export class RemoveCardComponent {

	constructor(
		readonly cardService: DriverCardService,
	) { }

	ngOnInit() {
		this.cardService.setTitle(
			marker(
				'tachomat.remove-device.driver-card.title-page'
			)
		);
		this.cardService.setSubtitle(
			marker(
				'tachomat.remove-device.driver-card.title-info'
			)
		);
	}

}
